import { render, staticRenderFns } from "./TreatmentEditor.vue?vue&type=template&id=1e1fa170&scoped=true"
import script from "./TreatmentEditor.vue?vue&type=script&lang=js"
export * from "./TreatmentEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1fa170",
  null
  
)

export default component.exports